import { Box } from '@mui/material';

const BLOCK_HATCH =
  'repeating-linear-gradient(45deg, #f0ede8, #f0ede8 3px, #e0ddd8 3px, #e0ddd8 6px)';
const OVERRIDE_HATCH =
  'repeating-linear-gradient(45deg, #fce8c8, #fce8c8 3px, #f5d89c 3px, #f5d89c 6px)';

export const COACHING_HATCH =
  'repeating-linear-gradient(135deg, rgba(164,164,164,0.32) 0, rgba(164,164,164,0.32) 1px, transparent 1px, transparent 6px)';
export const CHEMISTRY_HATCH =
  'repeating-linear-gradient(45deg, rgba(70,120,200,0.30) 0, rgba(70,120,200,0.30) 1px, transparent 1px, transparent 6px)';

const items = [
  { label: 'Session', swatch: { background: '#c8d4b8', border: '1px solid #5e8f3e' } },
  { label: 'Block',   swatch: { background: BLOCK_HATCH } },
  { label: 'Override', swatch: { background: OVERRIDE_HATCH } },
  { label: 'Available', swatch: { background: '#fff', border: '1px solid #e0ddd8' } },
];

const kindHatchItems = [
  { label: 'Coaching unavailable', swatch: { background: COACHING_HATCH, border: '1px solid #e0ddd8' } },
  { label: 'Chem Call unavailable', swatch: { background: CHEMISTRY_HATCH, border: '1px solid #e0ddd8' } },
];

export function LegendBar({ showKindHatches = false }: { showKindHatches?: boolean }) {
  const visibleItems = showKindHatches ? [...items, ...kindHatchItems] : items;
  return (
    <Box
      data-testid="event-calendar-legend"
      sx={{
        display: 'flex',
        gap: '14px',
        padding: '6px 22px',
        background: '#fff',
        borderBottom: '1px solid #e8e5e0',
        fontSize: 10,
        color: '#666',
        alignItems: 'center',
        flexShrink: 0,
      }}
    >
      {visibleItems.map(({ label, swatch }) => (
        <Box key={label} data-testid="event-calendar-legend-item" sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: '2px',
              flexShrink: 0,
              ...swatch,
            }}
          />
          <span data-testid="event-calendar-legend-label">{label}</span>
        </Box>
      ))}
    </Box>
  );
}
